import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Css/SideBar.css';

const Sidebar = ({ onSelect = () => { } }) => {
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const menuItems = [
        {
            icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#48752C"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z"/></svg>,
            label: 'विद्यार्थी व्यवस्थापन',
            path: '/dashboard/studentmanagment',
        },

        {
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9.3845 8.3845V7.3845H17.6155V8.3845H9.3845ZM9.3845 11.1538V10.1538H17.6155V11.1538H9.3845ZM14.2308 21V18.7905L19.5635 13.4827C19.6622 13.3968 19.7647 13.3333 19.8712 13.2923C19.9776 13.2513 20.084 13.2308 20.1905 13.2308C20.3007 13.2308 20.4122 13.2522 20.525 13.2952C20.6378 13.3381 20.7372 13.4025 20.823 13.4885L21.748 14.4327C21.8302 14.5314 21.8927 14.634 21.9355 14.7405C21.9785 14.8468 22 14.9532 22 15.0595C22 15.166 21.9827 15.2734 21.948 15.3818C21.9135 15.4901 21.8468 15.5936 21.748 15.6923L16.4405 21H14.2308ZM20.1905 16.0155L21.1155 15.0595L20.1905 14.1155L19.2405 15.0655L20.1905 16.0155ZM6 21C5.43583 21 4.9615 20.8077 4.577 20.423C4.19233 20.0385 4 19.5642 4 19V16.2308H7V3H20V10.8712C19.8205 10.8762 19.6497 10.8952 19.4875 10.928C19.3253 10.9607 19.1628 11.0071 19 11.0673V4H8V16.2308H13.3462L11.8463 17.7308V21H6Z" fill="#71839B" />
            </svg>
            , label: ' परीक्षा व्यवस्थापन', 
            path: '/dashboard/exammanagment',
        },
    ];

    const handleMenuClick = (label, path) => {
        onSelect(label);
        navigate(path);
    };

    const handleLogout = () => {

    setShowLogoutPopup(false);
    navigate("/"); 
};

    return (
        <>
            <div className={`main-container ${isCollapsed ? 'collapsed' : ''}`}>
                <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
                    <div className="logo-section">
                        {!isCollapsed && <svg xmlns="http://www.w3.org/2000/svg" width="230" height="50" viewBox="0 0 32 32" fill="none">
                            <rect width="32" height="32" rx="4" fill="#2D68FE" />
                            <path d="M15.9992 23.2031L9.76383 12.4031L22.2346 12.4031L15.9992 23.2031Z" fill="white" />
                        </svg>}
                        {!isCollapsed && <span className="logo-text">संस्थेचे नाव</span>}
                    </div>

                    <ul className="menu">
                        {menuItems.map((item, index) => (
                            <li
                                key={index}
                                className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
                                onClick={() => handleMenuClick(item.label, item.path)}
                            >
                                <span className="menu-item-img">
                                    {React.isValidElement(item.icon)
                                        ? React.cloneElement(item.icon, {
                                            style: { color: location.pathname === item.path ? '#848484' : '#ffff' },
                                        })
                                        : <img className="menu-item-img" src={item.icon} alt={item.label} />}
                                </span>

                                {!isCollapsed && item.label}
                            </li>
                        ))}
                    </ul>
                    <hr />
<div
  className={`settings-section ${location.pathname === "/settings" ? "active" : ""}`}
  onClick={() => navigate("settings")}
>
 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M10.1346 21L9.77306 18.1077C9.4539 18.0116 9.10873 17.8603 8.73756 17.6538C8.3664 17.4474 8.05073 17.2263 7.79056 16.9905L5.12306 18.125L3.25781 14.875L5.56356 13.1365C5.53406 12.9558 5.50973 12.7697 5.49056 12.578C5.47123 12.3863 5.46156 12.2001 5.46156 12.0192C5.46156 11.8512 5.47123 11.6747 5.49056 11.4895C5.50973 11.3042 5.53406 11.0955 5.56356 10.8635L3.25781 9.125L5.12306 5.9135L7.77131 7.02875C8.06998 6.78008 8.39306 6.55575 8.74056 6.35575C9.0879 6.15575 9.42565 6.00125 9.75381 5.89225L10.1346 3H13.8656L14.2271 5.9115C14.6104 6.04617 14.9491 6.20067 15.2433 6.375C15.5375 6.54933 15.8404 6.76725 16.1521 7.02875L18.8771 5.9135L20.7423 9.125L18.3596 10.9212C18.4147 11.1276 18.4456 11.317 18.4521 11.4895C18.4584 11.6618 18.4616 11.832 18.4616 12C18.4616 12.1552 18.4551 12.3189 18.4423 12.4913C18.4295 12.6637 18.4 12.8724 18.3538 13.1173L20.6981 14.875L18.8328 18.125L16.1521 16.9712C15.8404 17.2327 15.5269 17.4571 15.2116 17.6443C14.8962 17.8314 14.5681 17.9795 14.2271 18.0885L13.8656 21H10.1346ZM11.9731 14.5C12.6706 14.5 13.2616 14.2577 13.7463 13.773C14.2308 13.2885 14.4731 12.6975 14.4731 12C14.4731 11.3025 14.2308 10.7115 13.7463 10.227C13.2616 9.74233 12.6706 9.5 11.9731 9.5C11.2719 9.5 10.6799 9.74233 10.1971 10.227C9.7144 10.7115 9.47306 11.3025 9.47306 12C9.47306 12.6975 9.7144 13.2885 10.1971 13.773C10.6799 14.2577 11.2719 14.5 11.9731 14.5Z" fill="#71839B"/>
</svg>

  {!isCollapsed && <span>सेटिंग</span>}
</div>


                    <div className="logout-section" onClick={() => setShowLogoutPopup(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 20C10.891 20 9.85158 19.7913 8.88175 19.374C7.91192 18.9567 7.0645 18.3855 6.3395 17.6605C5.6145 16.9355 5.04333 16.0881 4.626 15.1183C4.20867 14.1484 4 13.109 4 12C4 10.891 4.20867 9.85158 4.626 8.88175C5.04333 7.91192 5.6145 7.0645 6.3395 6.3395C7.0645 5.6145 7.91192 5.04333 8.88175 4.626C9.85158 4.20867 10.891 4 12 4V5C10.05 5 8.39583 5.67917 7.0375 7.0375C5.67917 8.39583 5 10.05 5 12C5 13.95 5.67917 15.6042 7.0375 16.9625C8.39583 18.3208 10.05 19 12 19V20ZM16 16.2885L15.2923 15.575L18.3865 12.5H9.5V11.5H18.3673L15.2923 8.4L16 7.7115L20.2885 12L16 16.2885Z" fill="#71839B" />
                        </svg>
                        {!isCollapsed && <span>लॉगआउट</span>}
                    </div>
                </div>
            </div>

            {showLogoutPopup && (
                <div className="logout-popup-overlay">
                    <div className="logout-popup">
                        <button className="logout-close-btn" onClick={() => setShowLogoutPopup(false)}>×</button>

                        <div className="logout-popup-icon" >
                           <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 68 67" fill="none">
  <path d="M33.3333 66.6667C28.7125 66.6667 24.3816 65.7972 20.3406 64.0583C16.2997 62.3194 12.7688 59.9396 9.74792 56.9187C6.72708 53.8979 4.34722 50.367 2.60833 46.326C0.869444 42.2851 0 37.9542 0 33.3333C0 28.7125 0.869444 24.3816 2.60833 20.3406C4.34722 16.2997 6.72708 12.7688 9.74792 9.74792C12.7688 6.72709 16.2997 4.34722 20.3406 2.60833C24.3816 0.869442 28.7125 0 33.3333 0V4.16667C25.2083 4.16667 18.316 6.99653 12.6563 12.6562C6.99653 18.316 4.16667 25.2083 4.16667 33.3333C4.16667 41.4583 6.99653 48.3507 12.6563 54.0104C18.316 59.6701 25.2083 62.5 33.3333 62.5V66.6667ZM50 51.2021L47.051 48.2292L59.9438 35.4167H22.9167V31.25H59.8635L47.051 18.3333L50 15.4646L67.8688 33.3333L50 51.2021Z" fill="#FF1501"/>
</svg>
                        </div>

                        <h2>तुम्ही लॉगआउट करू इच्छिता?</h2>
                        <p>खात्री आहे का? लॉगआउट केल्यानंतर तुम्हाला पुन्हा लॉगिन करावे लागेल.</p>
                        <div className="logout-popup-buttons">
                            <button className="logout-cancel-btn" onClick={() => setShowLogoutPopup(false)}>रद्द करा</button>
                            <button className="logout-confirm-btn" onClick={handleLogout}>हो, लॉगआउट करा</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Sidebar;